import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";
import PageLoader from "../../components/PageLoader";

export default lazyPage(
    "src/front/pages/task/task.tsx",
    () => import("./task"),
    <PageLoader />,
);
